import React from "react";
import styles from "./index.module.css";
import {Divider, Table, TableBody, TableCell, TableHead, TableRow, View} from "@aws-amplify/ui-react";
import {useNavigate} from "react-router-dom";

const TopicsList = ({courseId = 0, lessonId = 0, topics = [], currentTopicId = 0}) => {
  const navigate = useNavigate();

  return topics.length > 0 ?
    (
      <View
        width="100%"
        padding="16px"
        className={styles.siderView}
      >
        <Table
          size="small"
          className={styles.topicsTable}
        >
          <TableHead>
            <TableRow>
              <TableCell
                as="th"
                fontWeight={900}
                className={styles.topicsTableCellHead}
              >
                Approfondimenti
              </TableCell>
            </TableRow>
          </TableHead>
          <Divider border="1px solid #9381ff" />
          <TableBody>
            {
              topics.map((topic, i) => {
                const {
                  id: topicId = 0,
                  title = "",
                } = topic || {};
                const cellClassNames = [styles.topicsTableCell];
                if (topicId === currentTopicId) {
                  cellClassNames.push(styles.topicsTableCellActive)
                }

                return (
                  <TableRow key={`topics_table_row_${topicId}`}>
                      <TableCell
                        style={i >= topics.length - 1 ? {borderBottom: "none"} : {}}
                        onClick={() => navigate(`/corsi/${courseId}/lezioni/${lessonId}/approfondimenti/${topicId}`)}
                        className={cellClassNames.join(" ")}
                      >
                        {title}
                      </TableCell>
                  </TableRow>
                )
              })
            }
          </TableBody>
        </Table>
      </View>
    ) :
    null
}

export default TopicsList;